export default {
  namespaced: true,
  state: () => ({
    selections: {},
  }),
  mutations: {
    setSelection(state, { key, deviceId }) {
      state.selections = { ...state.selections, [key]: String(deviceId) }
    },
  },
  getters: {
    getSelection: state => key => state.selections[key] ?? null,
  },
}
